(function (exports) {


    // Put functions into Modal
    function Modal(){}

    Modal.prototype.openModal = function(targetClass) {

        // If a modal form has any errors or content, clear all
        $(targetClass + ' *').filter('.input-error').each(function(){
            $(this).removeClass('input-error');
        });
        $(targetClass + ' *').filter('.help-block').each(function(){
            $(this).text('');
        });


        // Open modal
        $('body').addClass('fix-position');
        $(targetClass).addClass('modal__overlay--displayed');

        setTimeout(function() {
            $(targetClass).addClass('modal__overlay--active');
        }, 0);

    }

    Modal.prototype.closeModal = function() {

        $('.modal__overlay').removeClass('modal__overlay--active');

        setTimeout(function() {

            $('.modal__overlay').removeClass('modal__overlay--displayed');
            $('body').removeClass('fix-position');

        }, 250);
    }


    if (typeof define === 'function' && define.amd) {
        define(function() { return Modal.prototype; });
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = Modal.prototype;
    } else {
        exports.Modal = Modal.prototype;
    }

})(this);


$(document).ready(function() {

    $(document).on('click', '.close-site-modal', function (e) {
        e.preventDefault();

        $('.modal__overlay').removeClass('modal__overlay--active');

        setTimeout(function() {

            $('.modal__overlay').removeClass('modal__overlay--displayed');
            $('body').removeClass('fix-position');

        }, 250);

    });
});



// WEBPACK FOOTER //
// ./modal.js